import { signUp, confirmSignUp } from "aws-amplify/auth";
import "./Signup.css";
import { useState } from "react";
import { createUserAccount } from "../../Utils/functions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordInputValidation from "../PasswordInputValidation/PasswordInputValidation";

export const Signup = ({
  switchToLogin,
  setShowOtpInput,
  showOtpInput,
  email,
  setEmail,
}) => {
  const [error, setError] = useState("");
  const [userId, setUserId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      const signUpResult = await signUp({
        username: event.target.userSignUpEmail.value,
        password: event.target.userPassword.value,
      });
      setUserId(signUpResult.userId);
      setEmail(event.target.userSignUpEmail.value);
      event.target.reset();
      if (signUpResult.nextStep.signUpStep === "CONFIRM_SIGN_UP") {
        setShowOtpInput(true);
      }
    } catch (error) {
      console.error("Error during sign up", error);
      if (error.name === "UsernameExistsException") {
        setError(
          "An account with this email already exists. Please sign in instead."
        );
      } else if (error.name === "InvalidPasswordException") {
        setError("Password does not meet requirements.");
      } else {
        setError("An error occurred during sign up. Please try again.");
      }
    }
  };

  const handleOtpSubmit = async (event) => {
    event.preventDefault();
    const otpCode = event.target.otp.value;
    try {
      const { nextStep: confirmSignUpNextStep } = await confirmSignUp({
        username: email,
        confirmationCode: otpCode,
      });
      if (confirmSignUpNextStep.signUpStep === "DONE") {
        try {
          await createUserAccount(email, userId);
          setEmail("");
          setUserId("");
          const redirectPath = new URLSearchParams(location.search).get(
            "redirect"
          );
          navigate(redirectPath || "/");
          setTimeout(() => {
            setShowOtpInput(false);
          }, 100);
        } catch (tokenError) {
          console.error("Error during send token", tokenError);
        }
      }
    } catch (error) {
      console.error("Error confirming signup:", error);
      if (error.name === "CodeMismatchException") {
        setError("Invalid verification code. Please try again.");
      } else {
        setError("Error during verification. Please contact support.");
      }
    }
  };
  return (
    <div className="Signup">
      <h2>Sign up</h2>
      {error && <div className="error-message">{error}</div>}
      {!showOtpInput ? (
        <form onSubmit={handleSubmit}>
          <input
            name="userSignUpEmail"
            type="email"
            placeholder="Email"
            required
          />
          <PasswordInputValidation name="userPassword" placeholder="Password" />
          <button type="submit">SIGN UP</button>
          <p>
            Already have an account?{" "}
            <button onClick={switchToLogin}>LOG IN</button>
          </p>
        </form>
      ) : (
        <form onSubmit={handleOtpSubmit}>
          <p>Please enter the verification code sent to {email}</p>
          <input
            name="otp"
            type="text"
            placeholder="Enter verification code"
            required
          />
          <button type="submit">Verify Email</button>
        </form>
      )}
    </div>
  );
};
